import React, { useEffect, useState, useContext } from "react";
import API from "../../../../../Functions/API/api";
import "./DailySuggestionsList.css";
import LoadingPage from "../../../../../Error/LoadingPage/LoadingPage";
import { renderStatementWithKaTeX } from "../../../../../Status";
import { AuthContext } from "../../../../../context/authContext";

const DailySuggestionsList = ({ chosenDate }) => {
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(true);
  const { user } = useContext(AuthContext);

  const fetchSuggestions = async () => {
    if (!chosenDate) return;
    setLoading(true);
    try {
      const isoDate = new Date(chosenDate).toISOString();
      const res = await API.get(
        `/DailyProblemSuggestion/${isoDate}`
      );
      setSuggestions(res.data.problems || []);
    } catch (err) {
      console.error(err);
      setSuggestions([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSuggestions();
  }, [chosenDate]);

  const handleVote = async (authorId) => {
    try {
      await API.post(
        `/DailyProblemSuggestion/${new Date(
          chosenDate
        ).toISOString()}/${authorId}/vote`,
        { userId: user._id }
      );
      fetchSuggestions(); // Refresh list after voting
    } catch (err) {
      console.error(err);
      alert(err.response?.data?.error || "Failed to vote");
    }
  };

  const handleDelete = async (authorId) => {
    if (!window.confirm("Are you sure you want to delete this suggestion?")) return;
    try {
      await API.delete(
        `/DailyProblemSuggestion/${new Date(
          chosenDate
        ).toISOString()}/${authorId}`
      );
      fetchSuggestions(); // Refresh list after deletion
    } catch (err) {
      console.error(err);
      alert(err.response?.data?.error || "Failed to delete");
    }
  };

  if (loading) return <LoadingPage />;
  if (!suggestions.length) return <p>No suggestions for this day yet.</p>;

  return (
    <div className="DailySuggestionsList-container">
      <h3>Suggested Problems for {new Date(chosenDate).toDateString()}</h3>
      <div className="DailySuggestionsList">
        {suggestions.map((p, index) => (
          <div key={index} className="DailySuggestion-item">
            <h2 className="DailySuggestion-item-heading">
              🔍 Problem Suggested by : {p.author.name}
            </h2>
            <div className="DailySuggestion-item-content">
              <div className="DailySuggestion-item-content-tags">
                <span className={`pod-difficulty ${p.difficulty.toLowerCase()}`}>
                  {p.difficulty}
                </span>
                <span className="pod-field">{p.field}</span>
                <span className="pod-source">{p.source}</span>
              </div>
              <h3 className="DailySuggestion-item-content-statement">
                {renderStatementWithKaTeX(p.statement)}
              </h3>
              <div className="Suggestion-votes">
                <p>Total Votes : {p.votes ? p.votes.length : 0}</p>
                <div className="Suggestion-votes-buttons">
                 <button
  className="Vote"
  onClick={() => handleVote(p.author._id)}
>
  {p.votes?.some(id => id.toString() === user._id.toString())
    ? "Remove Vote"
    : "Vote for this problem"}
</button>
                  {p.author._id === user._id && (
                    <button className="Del" onClick={() => handleDelete(p.author._id)}>
                      Delete Suggestion
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DailySuggestionsList;
